import { Skeleton } from '@/components/ui/skeleton'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { usePressKit } from '../hooks/usePressKit'
import { PressKitBioSection } from '../components/PressKitBioSection'
import { PressKitAssetsSection } from '../components/PressKitAssetsSection'
import { PressKitReleasesSection } from '../components/PressKitReleasesSection'
import { PressKitCoverageSection } from '../components/PressKitCoverageSection'

export function PressKitPage() {
  const { config, stats, assets, releases, coverage, loading } = usePressKit()

  if (loading) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 space-y-12">
        <div className="space-y-3">
          <Skeleton className="h-10 w-1/3" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        <div className="grid grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-20 rounded-lg" />)}
        </div>
        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-16 rounded-lg" />)}
        </div>
      </div>
    )
  }

  if (!config?.isPublished) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16">
        <h1 className="text-4xl font-bold tracking-tight mb-4">Press Kit</h1>
        <p className="text-muted-foreground">The press kit is not available yet. Please check back soon.</p>
      </div>
    )
  }

  const sections: { value: string; title: string; node: React.ReactNode }[] = [
    { value: 'bio', title: config.bioTitle || 'About', node: <PressKitBioSection config={config} stats={stats} /> },
  ]
  if (assets.length > 0) {
    sections.push({ value: 'assets', title: 'Brand Assets', node: <PressKitAssetsSection assets={assets} /> })
  }
  if (releases.length > 0) {
    sections.push({ value: 'releases', title: 'Press Releases', node: <PressKitReleasesSection releases={releases} /> })
  }
  if (coverage.length > 0) {
    sections.push({ value: 'coverage', title: 'Media Coverage', node: <PressKitCoverageSection coverage={coverage} /> })
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 space-y-10">
      <header>
        <h1 className="text-4xl font-bold tracking-tight mb-2">Press Kit</h1>
        <p className="text-muted-foreground text-sm">
          Resources for journalists and media professionals.
        </p>
      </header>

      <Accordion type="multiple" defaultValue={[sections[0]!.value]} className="w-full">
        {sections.map(({ value, title, node }) => (
          <AccordionItem key={value} value={value}>
            <AccordionTrigger className="text-xl font-semibold">{title}</AccordionTrigger>
            <AccordionContent className="pt-4 pb-8">{node}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
